var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spotBox"},[_c('div',{staticClass:"left_spot",style:({backgroundColor: _vm.left_backgroundColor, ..._vm.left_style})}),_c('div',{staticClass:"right_spot",style:({backgroundColor: _vm.right_backgroundColor, ..._vm.right_style})}),_c('div',{staticClass:"title",style:(_vm.title_style)},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }